export default __webpack_public_path__ + "WaelDehmani.0c5fb84.png";